import reducerConstant from 'common/reducerConstants';

export function getProject(obj) {
  return {
    type: reducerConstant.getProject,
  };
}
export function getProjectSuccess(obj) {
  return {
    type: reducerConstant.getProjectSuccess,
    payload: {
      ...obj,
    },
  };
}
export function getProjectFailed(obj) {
  return {
    type: reducerConstant.getProjectFailed,
    payload: {
      ...obj,
    },
  };
}
export function getProjectById(obj) {
  return {
    type: reducerConstant.getProjectById,
    payload: {
      ...obj,
    },
  };
}
export function getProjectByIdSuccess(obj) {
  return {
    type: reducerConstant.getProjectByIdSuccess,
    payload: {
      ...obj,
    },
  };
}
export function getProjectByIdFailed(obj) {
  return {
    type: reducerConstant.getProjectByIdFailed,
    payload: {
      ...obj,
    },
  };
}
export function resetProjectViewData() {
  return {
    type: reducerConstant.resetProjectViewData,
  };
}

export function getProjectMilestone(obj) {
  return {
    type: reducerConstant.getProjectMilestone,
    payload: {
      ...obj,
    },
  };
}
export function getProjectMilestoneSuccess(obj) {
  return {
    type: reducerConstant.getProjectMilestoneSuccess,
    payload: {
      ...obj,
    },
  };
}
export function getProjectMilestoneFailed(obj) {
  return {
    type: reducerConstant.getProjectMilestoneFailed,
    payload: {
      ...obj,
    },
  };
}
